module.exports = __webpack_public_path__ + "media/services_overview/smart-sales-conversation-226c3f48.webp";